import { FC, memo, useMemo } from 'react';
import { Badge } from '@chakra-ui/react';

import { STATUS_TO_COLOR_PALETTE_MAP } from './constants/statusPalette';
import { StatusBadgeProps } from './types/StatusBadgeProps';

const StatusBadgeComponent: FC<StatusBadgeProps> = ({ status, ...props }) => {
  const colorPalette = useMemo(
    () => STATUS_TO_COLOR_PALETTE_MAP[status],
    [status],
  );

  return <Badge colorPalette={colorPalette} size="sm" {...props} />;
};

export const StatusBadge = memo(StatusBadgeComponent);
